"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const CsvHelper_1 = require("utils/CsvHelper");
const numberRegex = /^\d+$/;
const textRegex = /^[A-Za-z\s!@#$%^&*()_+={}[\]:;"'<>,.?\/|\\-]+$/;
const useValidateCSV = () => {
    const [fileErrorMessage, setFileErrorMessage] = (0, react_1.useState)(null);
    const validateHeaders = (key, headers) => {
        for (let index = 0; index < headers.length; index++) {
            const csvHeader = Object.keys(key)[index];
            const header = headers[index].name;
            if (csvHeader != header) {
                return {
                    error: `"${csvHeader}" header is incorrect; the expected is "${header}"`
                };
            }
        }
        return { error: '' };
    };
    const validateRequireColumn = (header, key) => {
        const isRequired = header.required;
        const columnName = header.name;
        return isRequired && (!key[columnName] || key[columnName] == '');
    };
    const validateNumberOnlyColumn = (header, key) => {
        const type = header.type;
        const columnName = header.name;
        return (type == 'number' &&
            key[columnName] != '' &&
            key[columnName] != 'null' &&
            !numberRegex.test(key[columnName]));
    };
    const validateTextOnlyColumn = (header, key) => {
        const type = header.type;
        const columnName = header.name;
        return (type == 'text' &&
            key[columnName] != '' &&
            key[columnName] != 'null' &&
            !textRegex.test(key[columnName]));
    };
    const validateRequireLength = (header, key) => {
        const requiredLength = header.requiredLength;
        const columnName = header.name;
        return (requiredLength &&
            requiredLength > 0 &&
            key[columnName].length > 0 &&
            key[columnName].length != requiredLength);
    };
    const validateDependantColumn = (header, key) => {
        const columnName = header.name;
        const dependantName = header.dependantName;
        if (!dependantName) {
            return false;
        }
        return key[columnName].length == 0 && key[dependantName].length > 0;
    };
    const validateEachColumn = (header, key, row) => {
        const type = header.type;
        const requiredLength = header.requiredLength;
        const maxLength = header.length;
        const columnName = header.name;
        if (validateRequireColumn(header, key)) {
            setFileErrorMessage(`${columnName} is required at row ${row}`);
            return false;
        }
        if (validateNumberOnlyColumn(header, key)) {
            setFileErrorMessage(`${columnName} should only be filled in ${type} at row ${row}`);
            return false;
        }
        if (validateTextOnlyColumn(header, key)) {
            setFileErrorMessage(`${columnName} should only be filled in ${type} at row ${row}`);
            return false;
        }
        if (validateMaxLengthColumn(header, key)) {
            setFileErrorMessage(`${columnName} should not be longer than ${maxLength} characters at row ${row}`);
            return false;
        }
        if (validateRequireLength(header, key)) {
            setFileErrorMessage(`${columnName} should be ${requiredLength} characters long at row ${row}`);
            return false;
        }
        if (validateDependantColumn(header, key)) {
            setFileErrorMessage(`${columnName} is required because ${header.dependantName} is filled at row ${row}`);
            return false;
        }
        return true;
    };
    const validateMaxLengthColumn = (header, key) => {
        const maxLength = header.length;
        const columnName = header.name;
        return maxLength && maxLength > 0 && key[columnName].length > maxLength;
    };
    const validateCSV = async (headers, file, parseOptions) => {
        const parsedData = await (0, CsvHelper_1.ParseFile)(file, parseOptions);
        let flag = true;
        let editedParsedData = (0, cloneDeep_1.default)(parsedData);
        editedParsedData.map((key, index) => {
            const row = index + 1;
            const { error } = validateHeaders(key, headers);
            if (error) {
                setFileErrorMessage(error);
                flag = false;
                return { flag, editedParsedData };
            }
            headers.some((header) => {
                const isValid = validateEachColumn(header, key, row);
                if (!isValid) {
                    flag = false;
                    return { flag, editedParsedData };
                }
            });
        });
        editedParsedData = editedParsedData.filter((e) => e);
        return { flag, editedParsedData };
    };
    return {
        fileErrorMessage,
        setFileErrorMessage,
        validateCSV
    };
};
exports.default = useValidateCSV;
